import { EntityDetails as DefaultEntityDetails } from "src/components/feature/Onboarding";

const EntityDetails = () => {
  return <DefaultEntityDetails />;
};

export default EntityDetails;
